import i18n from '@/i18n/index.ts'

export default function useValidators() {
    const isEmpty = (fieldName, fieldValue) => {
     return !fieldValue ? i18n.t("form.fieldreq") : "";
    }
    const minLength = (fieldName, fieldValue, min) => {
         return fieldValue.length < min ? i18n.t("form.Atleast",{ min: min }) : "";
   }
   const isTheSame = (fieldName, fieldValue, passwordvalue) => {
    return fieldValue != passwordvalue ? i18n.t("auth.reset.passwordMustBeTheSame") : "";
}
   const isEmail = (fieldName, fieldValue) => {
    let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return !re.test(fieldValue) ? i18n.t("auth.login.emailMustBe") : "";
}
   return {isEmpty, minLength,isEmail,isTheSame}
 }